<template>
  <div>
    <div class="row mb-3">
      <div class="col-md-12">
        <div class="alert alert-info" v-if="solicitud.estado === 'CONTRATADA'">
          <i class="fa fa-info-circle me-2"></i>
          El contrato/orden ha sido generado. Proceda a registrar la recepción de bienes/servicios.
        </div>
        <div class="alert alert-success" v-else-if="solicitud.estado === 'RECIBIDA'">
          <i class="fa fa-check-circle me-2"></i>
          <strong>Recepción conforme registrada</strong> - Los bienes/servicios han sido recibidos y verificados.
        </div>
      </div>
    </div>

    <!-- Formulario de recepción -->
    <div class="row" v-if="solicitud.estado === 'CONTRATADA'">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header bg-light"><h6 class="mb-0">Registrar Recepción</h6></div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-3">
                <div class="form-group mb-2">
                  <label class="form-label">Fecha Recepción *</label>
                  <input v-model="recepcion.fecha_recepcion" type="date" class="form-control" required>
                </div>
              </div>
              <div class="col-md-5">
                <div class="form-group mb-2">
                  <label class="form-label">Tipo Reporte *</label>
                  <select v-model="recepcion.tipo_reporte" class="form-select" required>
                    <option value="ACTA_RECEPCION">Acta de Recepción (Conforme)</option>
                    <option value="INFORME_DISCONFORMIDAD">Informe de Disconformidad</option>
                    <option value="INFORME_CONFORMIDAD_TECNICA">Informe de Conformidad Técnica</option>
                  </select>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group mb-2">
                  <label class="form-label">Conforme</label>
                  <select v-model="recepcion.conforme" class="form-select">
                    <option :value="true">Sí</option>
                    <option :value="false">No</option>
                  </select>
                </div>
              </div>
              <!--
              <div class="col-md-3">
                <div class="form-group mb-2">
                  <label class="form-label">Archivo Acta/Informe *</label>
                  <input type="file" @change="handleFileUpload" class="form-control" accept=".pdf">
                </div>
              </div>
              -->
              <div class="col-md-12">
                <div class="form-group mb-2">
                  <label class="form-label">Observaciones</label>
                  <textarea v-model="recepcion.observaciones" class="form-control" rows="2"></textarea>
                </div>
              </div>
              <div class="col-md-12 mt-2">
                <BButton variant="primary" @click="guardarRecepcion" :disabled="loading">
                  <i class="fa fa-save me-1"></i> Registrar Recepción
                </BButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Historial de recepciones -->
    <div class="row mt-3" v-if="recepciones.length > 0">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header bg-light"><h6 class="mb-0">Historial de Recepciones</h6></div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-sm table-bordered">
                <thead>
                  <tr><th>Fecha</th><th>Tipo</th><th>Conforme</th><th>Observaciones</th><th>Archivo</th></tr>
                </thead>
                <tbody>
                  <tr v-for="item in recepciones" :key="item.id">
                    <td>{{ formatDate(item.fecha_recepcion) }}</td>
                    <td>{{ formatTipoRecepcion(item.tipo_reporte) }}</td>
                    <td class="text-center"><i v-if="item.conforme" class="fa fa-check-circle text-success"></i><i v-else class="fa fa-times-circle text-danger"></i></td>
                    <td>{{ item.observaciones || '-' }}</td>
                    <td class="text-center">
                      <!-- Botón para generar PDF -->
                      <BButton 
                        variant="danger" 
                        size="sm"
                        @click="generarPdf(item.id)"
                        :disabled="generandoPdf"
                        class="me-1"
                        :title="item.tipo_reporte === 'ACTA_RECEPCION' ? 'Generar Acta de Recepción PDF' : 'Generar Informe de Disconformidad PDF'"
                      >
                        <i v-if="generandoPdf" class="fa fa-spinner fa-spin"></i>
                        <i v-else class="fa fa-file-pdf"></i> PDF
                      </BButton>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import axios from 'axios';
import Swal from 'sweetalert2';
import { BButton } from 'bootstrap-vue-3';

const props = defineProps({ solicitud: { type: Object, required: true } });
const emit = defineEmits(['refresh']);

const loading = ref(false);
const generandoPdf = ref(false);
const archivoSeleccionado = ref(null);
const recepciones = ref([]);

const recepcion = ref({
  fecha_recepcion: new Date().toISOString().split('T')[0],
  tipo_reporte: 'ACTA_RECEPCION',
  conforme: true,
  observaciones: ''
});

const fetchRecepciones = async () => {
  try {
    const response = await axios.get(`/recepcion/${props.solicitud.id}`);
    recepciones.value = response.data.data;
  } catch (error) { console.error(error); }
};

const handleFileUpload = (event) => { archivoSeleccionado.value = event.target.files[0]; };

const guardarRecepcion = async () => {
  /*
  if (!archivoSeleccionado.value) {
    Swal.fire('Error', 'Debe seleccionar el archivo del acta/informe', 'error');
    return;
  }
  */
  loading.value = true;
  try {
    const formData = new FormData();
    formData.append('id_solicitud', props.solicitud.id);
    formData.append('fecha_recepcion', recepcion.value.fecha_recepcion);
    formData.append('tipo_reporte', recepcion.value.tipo_reporte);
    formData.append('conforme', recepcion.value.conforme);
    formData.append('observaciones', recepcion.value.observaciones);
    // formData.append('archivo', archivoSeleccionado.value);

    const response = await axios.post('/recepcion/guardar', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
    Swal.fire('Éxito', response.data.message, 'success');
    archivoSeleccionado.value = null;
    recepcion.value.observaciones = '';
    fetchRecepciones();
    emit('refresh');
  } catch (error) {
    Swal.fire('Error', error.response?.data?.message || 'Error al registrar', 'error');
  } finally { loading.value = false; }
};

/**
 * Generar PDF del Acta de Recepción / Informe de Disconformidad
 * @param {number} recepcionId - ID de la recepción
 */
const generarPdf = async (recepcionId) => {
  generandoPdf.value = true;
  try {
    const response = await axios.get(`/recepcion/pdf/${recepcionId}`, {
      responseType: 'blob'
    });
    
    // Crear URL del blob y descargar
    const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    const recepcion = recepciones.value.find(r => r.id === recepcionId);
    const nombreArchivo = recepcion?.tipo_reporte === 'ACTA_RECEPCION'
      ? `acta_recepcion_${props.solicitud.codigo}.pdf`
      : `informe_disconformidad_${props.solicitud.codigo}.pdf`;
    
    link.href = blobUrl;
    link.setAttribute('download', nombreArchivo);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(blobUrl);
    
    Swal.fire('Éxito', 'PDF generado correctamente', 'success');
  } catch (error) {
    console.error('Error al generar PDF:', error);
    Swal.fire('Error', error.response?.data?.message || 'No se pudo generar el PDF', 'error');
  } finally {
    generandoPdf.value = false;
  }
};

const formatDate = (date) => date ? new Date(date).toLocaleDateString('es-BO') : 'N/A';
const formatTipoRecepcion = (tipo) => {
  const map = { 'ACTA_RECEPCION':'Acta Recepción','INFORME_DISCONFORMIDAD':'Disconformidad','INFORME_CONFORMIDAD_TECNICA':'Conformidad Técnica' };
  return map[tipo] || tipo;
};

onMounted(() => { fetchRecepciones(); });
</script>